$(document).ready(function(){
    //ANIMATION START
        gsap.registerPlugin(
        ScrollTrigger,
        ScrollToPlugin,
        SplitText
    );

    ScrollTrigger.defaults({    
        toggleActions: "play none play reset"
    });

    initAnimation();

    var tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 1.5,
        yoyo: true
    });

    function initAnimation() {
        jQuery('[data-animated]').each(function () {
        var ele = jQuery(this),
            ele_fade = ele.find('[data-fade]'),
            ele_fadeUp = ele.find('[data-fadeup]'),
            ele_fadeDown = ele.find('[data-fadedown]'),
            ele_fadeRight = ele.find('[data-faderight]'),
            ele_fadeLeft = ele.find('[data-fadeleft]');

            // if you want to show data fade please use fadeup attribute
            if(ele_fade.length) {
                gsap.fromTo(ele_fade, {opacity:0}, { duration: 0.3, opacity:1, stagger: 0.15,
                    scrollTrigger: {
                        trigger: this,
                        start: ele.attr('data-start') ? ele.attr('data-start') : "top 70%"
                    }
                });
            }

            // if you want to show data bottom to Top animation please use fadeup attribute
            if(ele_fadeUp.length) {
                gsap.fromTo(ele_fadeUp, {opacity:0, y:30}, { duration: 0.3, opacity:1, y:0, stagger: 0.15,
                    scrollTrigger: {
                        trigger: this,
                        start: ele.attr('data-start') ? ele.attr('data-start') : "top 70%"
                    }
                });
            }

            // if you want to show data Top to bottom animation please use fadedown attribute
            if(ele_fadeDown.length) {
                gsap.fromTo(ele_fadeDown, {opacity:0, y:-30}, { duration: 0.3, opacity:1, y:0, stagger: 0.15,
                    scrollTrigger: {
                    trigger: this,
                    start: ele.attr('data-start') ? ele.attr('data-start') : "top 70%"
                    } 
                });
            }

            // if you want to show data Right to Left animation please use fadeRight attribute
            if(ele_fadeRight.length) {
                gsap.fromTo(ele_fadeRight, {opacity:0, x:50}, { duration:0.3, opacity:1, x:0,
                    scrollTrigger: {
                    trigger: this,
                    start: ele.attr('data-start') ? ele.attr('data-start') : "top 70%"
                    }
                });
            }

            // if you want to show data Left to Right animation please use fadeLeft attribute
            if(ele_fadeLeft.length) {
                gsap.fromTo(ele_fadeLeft, {opacity:0, x:-50}, { duration:0.3, opacity:1, x:0,
                    scrollTrigger: {
                    trigger: this,
                    start: ele.attr('data-start') ? ele.attr('data-start') : "top 70%"
                    }
                });
            }
        });
    
    }
});